export enum BulkTradeRunStates {
  GENERATING = 'GENERATING',
  BULK_TRADES_INITIATED = 'BULK_TRADES_INITIATED',
  BULK_TRADES_FILES_GENERATING = 'BULK_TRADES_FILES_GENERATING',
  BULK_TRADES_REQUESTED = 'BULK_TRADES_REQUESTED',
  BULK_TRADES_COMPLETED = 'BULK_TRADES_COMPLETED',
  ALLOCATIONS_INITIATED = 'ALLOCATIONS_INITIATED',
  ALLOCATIONS_REQUESTED = 'ALLOCATIONS_REQUESTED',
  ALLOCATIONS_COMPLETED = 'ALLOCATIONS_COMPLETED',
  COMPLETED = 'COMPLETED',
  COMPLETED_PENDING_PTFS = 'COMPLETED_PENDING_PTFS',
  CANCELED = 'CANCELED',
}
